'use client';

import { MapPin, Phone } from 'lucide-react';
import { RefObject, useRef } from 'react';

import { clsx } from 'clsx';
import { useOnClickOutside } from 'usehooks-ts';

import { ICON_DEFAULT } from '@shared/constants/colors';
import { PHONE_NUMBER, PHONE_NUMBER_LINK } from '@shared/constants/contacts';
import { ROUTES } from '@shared/constants/routes';
import { useAppDispatch, useAppSelector } from '@shared/hooks/redux';
import { Button } from '@shared/ui/Button';
import { CustomLink } from '@shared/ui/CustomLink';
import { getViewPort } from '@shared/ui/ScreenSizeTracking';
// import { Socials } from '@shared/ui/Socials';
import { removePadding } from '@shared/utils/scrollHelpers/scrollHelpers';
import { openCallModal } from '@widgets/CallModal';
import { toggleMobileMenu } from '@widgets/Header/model/slice/headerSlice';

import { Links } from '../Links/Links';
import cls from './MobileMenu.module.scss';

type MobileMenuProps = {
  buttonRef: RefObject<HTMLElement>;
};

export const MobileMenu = ({ buttonRef }: MobileMenuProps) => {
  const dispatch = useAppDispatch();
  const hideSearch = useAppSelector((state) => state.header.hideSearch);
  const wrapRef = useRef<HTMLDivElement>(null);
  const viewPort = useAppSelector(getViewPort);

  const onCloseHandler = () => {
    if (viewPort !== 'mobile') return;
    dispatch(toggleMobileMenu(false));
    removePadding();
  };

  const openCallModalHandler = () => {
    dispatch(openCallModal());
    onCloseHandler();
  };

  const mods: Record<string, string | boolean | undefined> = {
    [cls.hideSearch]: hideSearch
  };

  useOnClickOutside([wrapRef, buttonRef], onCloseHandler);

  return (
    <div
      ref={wrapRef}
      className={clsx(cls.wrap, mods)}
      data-testid="mobile-menu"
    >
      <Links />

      <Button
        testId={'open-callModal-button'}
        size={'s'}
        onClick={openCallModalHandler}
        className={cls.call}
      >
        Перезвонить мне
      </Button>

      <div className={cls.contacts}>
        <CustomLink
          aria-label={`Позвонить на номер ${PHONE_NUMBER_LINK}`}
          href={`tel:${PHONE_NUMBER_LINK}`}
          iconPosition={'left'}
          icon={<Phone color={ICON_DEFAULT} />}
          className={cls.phone}
        >
          {PHONE_NUMBER}
        </CustomLink>

        <CustomLink
          href={ROUTES.MAIN}
          iconPosition={'left'}
          icon={<MapPin color={ICON_DEFAULT} />}
          className={cls.geo}
        >
          Н. Новгород
        </CustomLink>

        {/*<Socials className={cls.socials} />*/}
      </div>
    </div>
  );
};
